/**
 * implement in js for react native when not running with DOM
 */
function getEventSystem() {
    if (typeof window !== 'undefined' &&
        typeof window.addEventListener === 'function' &&
        typeof window.removeEventListener === 'function' &&
        typeof window.dispatchEvent === 'function') {
        return window;
    }
    var eventListeners = new Map();
    return {
        addEventListener: function (type, listener) {
            var listeners = eventListeners.get(type);
            if (!listeners) {
                listeners = new Set();
                eventListeners.set(type, listeners);
            }
            listeners.add(listener);
        },
        removeEventListener: function (type, listener) {
            var _a;
            (_a = eventListeners.get(type)) === null || _a === void 0 ? void 0 : _a.delete(listener);
        },
        dispatchEvent: function (event) {
            var _a;
            (_a = eventListeners.get(event.type)) === null || _a === void 0 ? void 0 : _a.forEach(function (listener) { return listener(event); });
        },
    };
}
export var eventSystem = getEventSystem();
//# sourceMappingURL=event-system.js.map